// @ts-check
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['ParticipantRoleDetail']} ParticipantRole */
/** @typedef {Schemas['ParticipantRoleCreateRequest']} ParticipantRoleCreate */
/** @typedef {Schemas['PatchedParticipantRoleUpdateRequest']} ParticipantRoleUpdate */

const BASE = '/api/participant-roles'

/**
 * GET /api/participant-roles/
 * @param {{ includeInactive?: boolean }} [params]
 * @returns {Promise<ParticipantRole[]>}
 */
export async function listParticipantRoles(params) {
  const { data } = await axios.get(`${BASE}/`, {
    params: params?.includeInactive ? { include_inactive: 'true' } : undefined,
  })
  return data
}

/**
 * POST /api/participant-roles/
 * @param {ParticipantRoleCreate} body
 * @returns {Promise<ParticipantRole>}
 */
export async function createParticipantRole(body) {
  const { data } = await axios.post(`${BASE}/`, body)
  return data
}

/**
 * PATCH /api/participant-roles/{id}/
 * @param {number} id
 * @param {ParticipantRoleUpdate} body
 * @returns {Promise<ParticipantRole>}
 */
export async function updateParticipantRole(id, body) {
  const { data } = await axios.patch(`${BASE}/${id}/`, body)
  return data
}

/**
 * POST /api/participant-roles/{id}/toggle-active/
 * @param {number} id
 * @returns {Promise<ParticipantRole>}
 */
export async function toggleParticipantRoleActive(id) {
  const { data } = await axios.post(`${BASE}/${id}/toggle-active/`)
  return data
}
